import React, { MouseEventHandler } from 'react';
import * as PlanDetailsUI from '../PlanDetailsUI';
import { PlanActionsAdmin } from '../PlanActions';

const NoReport = ({ onEdit }: { onEdit: MouseEventHandler }) => {
  return (
    <PlanDetailsUI.NoReportContainer>
      <PlanActionsAdmin onClick={onEdit} title="Add Report" />
    </PlanDetailsUI.NoReportContainer>
  );
};

export default NoReport;
